import { FeatureCollection, Polygon } from '@turf/helpers';
import { getAuthHeadersFromCookie } from 'lib/AuthClient/cookie';
import { useEffect, useState } from 'react';
import { settings } from 'settings';
import { Region } from 'types/orderTypes';

export const useCageZones = (region: Region) => {
  const [cageZones, setCageZones] = useState<FeatureCollection<
    Polygon,
    { zone: string }
  > | null>(null);

  useEffect(() => {
    fetch(`${settings.newApiUrl}/availability/geozone-overlay/${region}`, {
      headers: {
        Authorization: getAuthHeadersFromCookie()?.Authorization,
      },
    })
      .then(res => res.json())
      .then(res => {
        setCageZones(res);
      });
  }, [region]);

  return cageZones;
};
